import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {
    CircularProgress,
    Fade,
    TextField,
    Checkbox,
    Radio
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { NotificationManager } from 'react-notifications';
import { FormattedMessage, injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import { validateCustomerAddressForm } from '../../utils/validators/validateForm';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';
import { ROLE_CUSTOMER } from '../../utils/config/constants';
import { Scrollbars } from 'react-custom-scrollbars';
import Geosuggest from 'react-geosuggest';
import { Clear, Add, Remove, GpsFixed, LocationOn } from '@material-ui/icons';
const style = {
    width: '100%',
    height: '100%'
};

class AddAddressPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            closeVerification: false,
            error: '',
            address_line1: '',
            address_line1Error: '',
            city: '',
            cityError: '',
            state: '',
            stateError: '',
            country: '',
            countryError: '',
            pincode: '',
            pincodeError: '',
            phone: props.userData.phone ? props.userData.phone : '',
            phoneError: '',
            name: props.userData.name ? props.userData.name : '',
            nameError: '',
            emailError: '',
            email: props.userData.email ? props.userData.email : '',
            loader: false,
            pass: false,
            noResponse: false,
            errorMessage: '',
            latitude: '30.741482',
            longitude: '76.768066',
            type_id: 1,
            custam_type_id: 1,
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            addressAdded: false,
            centerLat: 30.741482,
            centerLng: 76.768066,
            is_default: false,
            added: false,
            color: "",
            backgroundcolor: ''
        };
    }
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.submit()}
                >
                    <FormattedMessage id="address.save" defaultMessage="Save" />
                </Button>
            );
        }
    };

    componentDidMount() {
        this.getPlace(this.state.centerLat, this.state.centerLng);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.setState(
                    {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    },
                    () => {
                        this.getPlace(
                            position.coords.latitude,
                            position.coords.longitude
                        );
                        return true;
                    }
                );
            });
        } else {
            // error => console.log(error);
        }
    }

    submit = params => {
        const {
            address_line1,
            city,
            state,
            country,
            pincode,
            name,
            email,
            phone,
            type_id,
            is_default
        } = this.state;
        if (
            validateCustomerAddressForm(
                {
                    address_line1,
                    city,
                    state,
                    country,
                    pincode,
                    name,
                    email,
                    phone
                },
                this.handleError
            )
        ) {
            this.setState({ loader: true });
            this.props.addAddressAction(
                {
                    address_line1,
                    city,
                    state,
                    country,
                    zipcode: this.state.pincode,
                    name,
                    email,
                    phone,
                    latitude: this.state.latitude
                        ? this.state.latitude
                        : this.state.centerLat,
                    longitude: this.state.longitude
                        ? this.state.longitude
                        : this.state.centerLng,
                    type_id,
                    is_default
                },
                this.onDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        }
    };
    handleError = params => {
        this.setState(params);
    };
    handleClose = () => {
        this.props.closePopup();
    };

    onDone = (success, data) => {
        this.setState({ loader: false });

        if (success) {
            this.handleClose();
            NotificationManager.success(data.message, 'Success');
        }
    };
    handleRadioChange = event => {
        this.setState({ type_id: event.target.value });
        // this.setState({ custam_type_id: event.target.value});


        //    this.setState({color: '#0078ff'});
        console.log("yoyo", event.target.value)

    };
    renderButton = () => {
        if (this.state.loader) {
            return <CircularProgress />;
        }
        return (
            <Button
                variant="raised"
                color="primary"
                className="jr-btn"
                onClick={this.submit}
            >
                <FormattedMessage id="add" defaultMessage="Add" />
            </Button>
        );
    };
    onMarkerClick = (props, marker, e) => {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };
    onMarkerDragEnd = (coord, index) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();

        this.setState({ latitude: lat, longitude: lng }, () => {
            this.getPlace(lat, lng);
        });
    };
    getPlace = async (lat, lng) => {
        var latLng = parseFloat(lat) + ',' + parseFloat(lng);

        const { data } = await axios({
            url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng}&key=${this.props.settings.constants.GOOGLE_MAP_KEY
                }`
        });

        if (data.status === 'OK') {
            if (data.results[0].formatted_address) {
                this.setState({
                    address_line1: data.results[0].formatted_address
                });
            }
            data.results[0].address_components.map(address => {
                if (address.types.includes('country')) {
                    this.setState({ country: address.long_name });
                } else if (address.types.includes('postal_code')) {
                    // pincode = address.long_name;
                    this.setState({ pincode: address.long_name });
                } else if (
                    address.types.includes('administrative_area_level_1')
                ) {
                    this.setState({ state: address.long_name });
                } else if (
                    address.types.includes('administrative_area_level_2') ||
                    address.types.includes('locality')
                ) {
                    this.setState({ city: address.long_name });
                }
            });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="googleApiNotWorking"
                    defaultMessage="Google Api not working, Please add address manually"
                />,
                'Error'
            );
        }
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    handleSelectPlace = event => {
        if (event) {
            this.setState(
                {
                    latitude: event.location.lat,
                    longitude: event.location.lng,
                    centerLat: event.location.lat,
                    centerLng: event.location.lng
                },
                () => {
                    this.getPlace(event.location.lat, event.location.lng);
                }
            );
        }
    };
    render() {
        const {
            address_line1,
            city,
            state,
            country,
            pincode,
            name,
            email,
            phone,
            loader,
            address_line1Error,
            cityError,
            stateError,
            countryError,
            pincodeError,
            phoneError,
            emailError,
            nameError,

            latitude,
            longitude
        } = this.state;
        const { formatMessage } = this.props.intl;
        const { userData } = this.props;
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    disableBackdropClick={false}
                    maxWidth={'sm'}
                    TransitionComponent={Fade}
                    className="service-modal"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div
                        className="modal-header dir-pop-head"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main
                        }}
                    >
                        <h4 className="dialog-heading">
                            {' '}
                            <FormattedMessage
                                id="address.addnew"
                                defaultMessage="Add New Address"
                            />
                        </h4>
                        <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleClose()
                        }} />
                    </div>
                    <div className="modal-body dir-pop-body">
                        <DialogContent className="service-from-body">
                            <Scrollbars>
                                <Card className="col-md-12">
                                    <div>
                                        <h4 className="my-3">
                                            <b>
                                                <FormattedMessage
                                                    id="markerNote"
                                                    defaultMessage="Note: Drag red marker on map to fetch location"
                                                />
                                            </b>
                                        </h4>
                                    </div>

                                    <div style={{ height: 200 }} className="position-relative">
                                        <Map
                                            centerAroundCurrentLocation={
                                                true
                                            }
                                            style={style}
                                            google={this.props.google}
                                            zoom={7}
                                            center={{
                                                lat: latitude,
                                                lng: longitude
                                            }}
                                        >
                                            <Marker
                                                position={{
                                                    lat: latitude,
                                                    lng: longitude
                                                }}
                                                draggable={true}
                                                onDragend={(
                                                    t,
                                                    map,
                                                    coord
                                                ) =>
                                                    this.onMarkerDragEnd(
                                                        coord
                                                    )
                                                }
                                            />
                                        </Map>
                                    </div>

                                    <div className="cpn-pag-form">
                                        <div>
                                            <Geosuggest
                                                suggestItemClassName="autosuggest-places"
                                                onSuggestSelect={this.handleSelectPlace}
                                                placeholder="Please Type in your address"
                                            />
                                        </div>
                                        <form
                                            className="row form-new"
                                            noValidate
                                            autoComplete="off"
                                            id="address-create"
                                        >
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={nameError ? true : false}
                                                    helperText={nameError}
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    label={formatMessage({
                                                        id: 'address.name'
                                                    })}
                                                    placeholder={formatMessage({
                                                        id:
                                                            'payment.nameplaceholder'
                                                    })}
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            name:
                                                                event.target.value,
                                                            nameError: ''
                                                        });
                                                    }}
                                                    value={name}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={
                                                        emailError ? true : false
                                                    }
                                                    helperText={emailError}
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    label={formatMessage({
                                                        id: 'address.email'
                                                    })}
                                                    placeholder="Enter Email"
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    onChange={event => {
                                                        this.setState({
                                                            email:
                                                                event.target.value,
                                                            emailError: ''
                                                        });
                                                    }}
                                                    margin="normal"
                                                    value={email}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={
                                                        phoneError ? true : false
                                                    }
                                                    helperText={phoneError}
                                                    type="text"
                                                    name="phone"
                                                    label="Phone Number"
                                                    id="phone"
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    placeholder="Add Phone"
                                                    onChange={event => {
                                                        this.setState({
                                                            phone:
                                                                event.target.value,
                                                            phoneError: ''
                                                        });
                                                    }}
                                                    margin="normal"
                                                    value={phone}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">

                                                <TextField
                                                    error={
                                                        address_line1Error
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={address_line1Error}
                                                    type="text"
                                                    name="address_line1"
                                                    label="Address"
                                                    id="address_line1"
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    placeholder="Add Address"
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            address_line1:
                                                                event.target.value,
                                                            address_line1Error: ''
                                                        });
                                                    }}
                                                    value={address_line1}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={cityError ? true : false}
                                                    helperText={cityError}
                                                    type="text"
                                                    name="city"
                                                    id="city"
                                                    label={formatMessage({
                                                        id: 'address.city'
                                                    })}
                                                    placeholder={formatMessage({
                                                        id: 'address.city'
                                                    })}
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            city:
                                                                event.target.value,
                                                            cityError: ''
                                                        });
                                                    }}
                                                    value={city}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={
                                                        stateError ? true : false
                                                    }
                                                    helperText={stateError}
                                                    type="text"
                                                    name="state"
                                                    id="state"
                                                    label={formatMessage({
                                                        id: 'address.state'
                                                    })}
                                                    placeholder={formatMessage({
                                                        id: 'address.state'
                                                    })}
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            state:
                                                                event.target.value,
                                                            stateError: ''
                                                        });
                                                    }}
                                                    value={state}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={
                                                        countryError ? true : false
                                                    }
                                                    helperText={countryError}
                                                    type="text"
                                                    name="country"
                                                    id="country"
                                                    label={formatMessage({
                                                        id: 'address.country'
                                                    })}
                                                    className="login-form-textfield"
                                                    placeholder={formatMessage({
                                                        id: 'address.country'
                                                    })}
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            country:
                                                                event.target.value,
                                                            countryError: ''
                                                        });
                                                    }}
                                                    value={country}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12">
                                                <TextField
                                                    error={
                                                        pincodeError ? true : false
                                                    }
                                                    helperText={pincodeError}
                                                    type="text"
                                                    name="pincode"
                                                    label="Pincode"
                                                    id="pincode"
                                                    fullWidth
                                                    className="login-form-textfield"
                                                    placeholder="Add Pincode"
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            pincode:
                                                                event.target.value,
                                                            pincodeError: ''
                                                        });
                                                    }}
                                                    value={pincode}
                                                    disabled={loader ? true : false}
                                                />
                                            </div>
                                            {userData.role === ROLE_CUSTOMER && (
                                                <div className="col-md-12 ">
                                                    <div className="row">
                                                        <div className="col-md-4">x``
                                                            <div className="row">
                                                                <Radio
                                                                    className="checked-radio"
                                                                    checked={
                                                                        this.state.type_id == 1
                                                                    }
                                                                    onChange={event =>
                                                                        this.handleRadioChange(
                                                                            event
                                                                        )
                                                                    }
                                                                    // onChange={this.handlePaymentOption}
                                                                    value="1"
                                                                    color="primary"
                                                                //  style={{ backgroundColor: this.state.color }}
                                                                />
                                                                <p className="addreschange" style={{ display: "flex", alignItems: "center" }}><FormattedMessage
                                                                    id="home"
                                                                    defaultMessage="Home"

                                                                /></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="row">
                                                                <Radio
                                                                    className="checked-radio"
                                                                    checked={
                                                                        this.state.type_id == 2
                                                                    }
                                                                    onChange={event =>
                                                                        this.handleRadioChange(
                                                                            event
                                                                        )
                                                                    }
                                                                    value="2"
                                                                    color="primary"
                                                                // style={{ backgroundColor: this.state.color }}
                                                                />
                                                                <p className="addreschange" style={{ display: "flex", alignItems: "center" }}><FormattedMessage
                                                                    id="work"
                                                                    defaultMessage="Work"
                                                                /></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="row">
                                                                <Radio
                                                                    className="checked-radio"
                                                                    checked={
                                                                        this.state.type_id == 3
                                                                    }
                                                                    onChange={event =>
                                                                        this.handleRadioChange(
                                                                            event
                                                                        )
                                                                    }
                                                                    value="3"
                                                                    color="primary"
                                                                // style={{ backgroundColor: this.state.color }}
                                                                />
                                                                <p className="addreschange" style={{ display: "flex", alignItems: "center" }}><FormattedMessage
                                                                    id="other"
                                                                    defaultMessage="Other"
                                                                /></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-md-12 ">
                                                <div className="row">
                                                    <Checkbox
                                                        checked={this.state.is_default}
                                                        onChange={this.handleChange(
                                                            'is_default'
                                                        )}
                                                        value="is_default"
                                                        color="primary"
                                                    />
                                                    <p className="addreschange" style={{ display: "flex", alignItems: "center" }}><FormattedMessage
                                                        id="setAsOffice"
                                                        defaultMessage="Set as Default"
                                                    /></p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </Card>
                            </Scrollbars>
                        </DialogContent>
                        <DialogActions>
                            <div className="col-md-12">
                                {this.renderButton()}
                            </div>
                        </DialogActions>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),
    GoogleApiWrapper(props => ({
        apiKey: props.settings.constants.GOOGLE_MAP_KEY
    })),
    connect(
        null,
        actions
    )
);
export default composedHOC(injectIntl(AddAddressPopup));



// WEBPACK FOOTER //
// ./src/components/Booking/AddAddressPopup.jsx